export class Email {
    email!: string;
    usuario!: string;
    fazenda!: string;
    cdfazenda!: number;
    dataCadastro!: Date;
    codigo!: string;
    admin?: boolean;
}
